import axios from 'axios';
import config from '../config';

const getAuthToken = () => {
    return localStorage.getItem('accessToken');
};

export const chatbotService = {
    sendMessage: async (message) => {
        try {
            const token = getAuthToken();
            const response = await axios.post(
                `${config.API_BASE_URL}/api/integrations/chatbot/ask/`,
                { message },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error sending message to chatbot:', error);
            throw error;
        }
    },

    getHistory: async (sessionId = null) => {
        try {
            const token = getAuthToken();
            const url = sessionId
                ? `${config.API_BASE_URL}/api/integrations/chatbot/history/?session_id=${sessionId}`
                : `${config.API_BASE_URL}/api/integrations/chatbot/history/`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching chat history:', error);
            throw error;
        }
    },

    getSessions: async () => {
        try {
            const token = getAuthToken();
            const response = await axios.get(
                `${config.API_BASE_URL}/api/integrations/chatbot/sessions/`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching chat sessions:', error);
            throw error;
        }
    },

    /**
     * Transcribe audio only (no agent call).
     * @param {Blob} audioBlob — recorded audio blob
     * @returns {{ transcript: string }}
     */
    transcribeAudio: async (audioBlob) => {
        try {
            const token = getAuthToken();
            const formData = new FormData();
            formData.append('audio', audioBlob, 'recording.webm');
            const response = await axios.post(
                `${config.API_BASE_URL}/api/integrations/chatbot/voice/transcribe/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error transcribing audio:', error);
            throw error;
        }
    },

    /**
     * Send audio to the chatbot voice endpoint (transcribe + agent).
     * @param {Blob} audioBlob — recorded audio blob
     * @returns {{ transcript: string, response: string }}
     */
    sendVoiceMessage: async (audioBlob) => {
        try {
            const token = getAuthToken();
            const formData = new FormData();
            formData.append('audio', audioBlob, 'recording.webm');
            const response = await axios.post(
                `${config.API_BASE_URL}/api/integrations/chatbot/voice/ask/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error sending voice message:', error);
            throw error;
        }
    }
};
